/**
 * The id of the contacts selector which is used in the Contacts page to display the main list of contacts.
 * @type {string}
 */
export const CONTACTS_PAGE_FIXED_SELECTOR_ID = 'contacts-page-fixed-id';
const UserType = {
    USER: 'user',
    GROUP: 'group',
    CARTRACKER: 'cartracker',
    ROBOT: 'robot',
    THREE_GPP: '3gpp',
    EXTERNAL_VIDEO_SOURCE: 'external_video_source',
    EXTERNAL_VIDEO_DESTINATION: 'external_video_destination',
};
export const UserDeviceOs = {
    ANDROID: 'android',
    IOS: 'ios',
    WEBCHAT: 'webchat',
    CARTRACKER: 'cartracker',
    THREE_GPP: '3gpp',
    THREE_GPP_IWF: 'iwf',
    EXTERNAL_VIDEO_SOURCE: 'external_video_source',
    EXTERNAL_VIDEO_DESTINATION: 'external_video_destination',
};
const UserAvailability = {
    AVAILABLE: 0,
    BUSY: 1,
};
const RobotType = {
    ROBOT_SYSTEM: 'ROBOT_SYSTEM',
    ROBOT_MY_RULES: 'ROBOT_MY_RULES',
};

export { UserType, UserAvailability, RobotType };

export const ContactMenuType = {
    NONE: 'NONE',
    CONTACTS_PAGE: 'CONTACTS_PAGE',
    CHANNELS_PAGE: 'CHANNELS_PAGE',
    GEOLOCATION_PAGE: 'GEOLOCATION_PAGE',
};

export const ContactMenuOption = {
    MESSAGE: 'MESSAGE',
    VOIP_CALL: 'VOIP_CALL',
    VIDEO_CALL: 'VIDEO_CALL',
    PTT_CALL: 'PTT_CALL',
    PBX_CALL: 'PBX_CALL',
    CONFERENCE_CALL: 'CONFERENCE_CALL',
    BROADCAST_CALL: 'BROADCAST_CALL',
    SHARE_SCREEN: 'SHARE_SCREEN',
    BROADCAST_VIDEO: 'BROADCAST_VIDEO',
    JOIN_BROADCAST_VIDEO: 'JOIN_BROADCAST_VIDEO',
    RESTRICTED_ROOM: 'RESTRICTED_ROOM',
    DETAILS: 'DETAILS',
    ADD_TO_FAVORITES: 'ADD_TO_FAVORITES',
    REMOVE_FROM_FAVORITES: 'REMOVE_FROM_FAVORITES',
    ADD_TO_CONTACTS: 'ADD_TO_CONTACTS',
    REMOVE_FROM_CONTACTS: 'REMOVE_FROM_CONTACTS',
    MY_BUSINESS_PROCESSES_LIST: 'MY_BUSINESS_PROCESSES_LIST',
    GEOLOCATION_REPORTS: 'GEOLOCATION_REPORTS',
    USER_GROUP_EDIT: 'USER_GROUP_EDIT',
    USER_GROUP_DELETE: 'USER_GROUP_DELETE',
    USER_GROUP_CREATE: 'USER_GROUP_CREATE',
    GROUP_CONVERSATION: 'GROUP_CONVERSATION',
    BROADCAST_MESSAGE: 'BROADCAST_MESSAGE',
    TRANSFER_CALL: 'TRANSFER_CALL',
    ADD_CALL_PARTICIPANTS: 'ADD_CALL_PARTICIPANTS',
    SHARE_CHANNEL: 'SHARE_CHANNEL',
    // SHARE either SEPARATELY (broadcast) or in a GROUP; ex: Share room
    MIXED_SHARE: 'MIXED_SHARE',
    // FORWARD either SEPARATELY (broadcast) or in a GROUP; ex: Forward a message
    MIXED_FORWARD: 'MIXED_FORWARD',
    // send an RBR to selected contacts
    REACH_BACK_REQUEST: 'REACH_BACK_REQUEST',
    INVITE_GUEST: 'INVITE_GUEST',
    DIALER: 'DIALER',
};

export const GuestInvitationFieldLength = {
    FIRST_NAME: '100',
    LAST_NAME: '100',
    DETAILS: '200',
};

/**
 * The ways of execution of a mixed action:
 * - single => one contact selected
 * - separate => will exec the action for each contact (similar to a broadcast)
 * - group => will create a group conversation with The Boys
 * @type {{}}
 */
export const MixedActionMode = {
    SINGLE: 'single',
    SEPARATE: 'separate',
    GROUP: 'group',
};

export const CugContactType = {
    DEPARTMENT_CONTACT: 0,
    MANUALLY_ADDED_CONTACT: 1,
};

export const SearchInputDefaultData = {
    keyword: '',
    userIsTyping: false,
    requestInProgress: false,
    requestNextOffset: false,
    matches: {
        msisdns: [],
        groupsIds: [],
        totalRecordsCount: 0,
    },
    hasMoreRecords: true,
};

export const ALL_GROUP_ID = -1;
